<div class="landing-page">
  <app-info-bar></app-info-bar>
  @if (isLoaded()) {
    <div class="landing-page__content esign-check-in-step-content">
      <h1 class="esign-responsive-heading" data-testid="welcome-title">
        {{ "landing-page.heading" | translate: { name: firstName() } }}
      </h1>

      <app-share-link-banner></app-share-link-banner>

      <div class="esign-card card-content">
        <div class="steps">
          <h2 class="steps__heading esign-responsive-card-title">
            {{ "landing-page.card-title" | translate }}
          </h2>

          <ul class="steps__list nova-body-large">
            @for (step of steps(); track step.i18nKey) {
              <li class="steps__list__item">
                <nova-icon [name]="step.iconName" />
                <div>
                  <p class="nova-label-16">
                    {{ `landing-page.steps.${step.i18nKey}.title` | translate }}
                  </p>
                  <p class="steps__list__item__description nova-body-14">
                    {{
                      `landing-page.steps.${step.i18nKey}.description`
                        | translate
                    }}
                  </p>
                </div>
              </li>
            }
          </ul>
        </div>

        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>

        <app-legal-acknowledgement-footer
          [buttonText]="'landing-page.button-text' | translate"
        ></app-legal-acknowledgement-footer>
      </div>
    </div>
  }
</div>

@if (isLoaded()) {
  <div class="esign-action-footer">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
}

<ng-template #actionButtons>
  <button
    novaButton
    appTrackedButton
    data-testid="get-started-button"
    [trackId]="'landing-page:start'"
    [trackType]="'continue'"
    [disabled]="isSubmitting()"
    (click)="navigateToNextStep()"
  >
    {{ "landing-page.button-text" | translate }}
  </button>
</ng-template>
